import { Routes, Route, Navigate } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';
import { StatusGatePage } from '@/pages/StatusGatePage';
import { PersonaSelectPage } from '@/pages/PersonaSelectPage';
import { CallPage } from '@/pages/CallPage';

export function AppRoutes() {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-black">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-white border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    loginWithRedirect({ appState: { returnTo: window.location.pathname } });
    return null;
  }

  return (
    <Routes>
      <Route path="/" element={<StatusGatePage />} />
      <Route path="/personas" element={<PersonaSelectPage />} />
      <Route path="/call/:personaId" element={<CallPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
